import { Modal } from "bootstrap";
import * as constants from "../constants";

export class ContactForm {
    init(): void {
        const contactFormElement = <HTMLFormElement | null>document.getElementById(constants.ContactFormElementId);
                
        if (contactFormElement) {
            contactFormElement.addEventListener('submit', (event) => {
                const isFormValid = contactFormElement.checkValidity();

                event.preventDefault();
                event.stopPropagation();
                contactFormElement.classList.add("was-validated");
                
                if(isFormValid === false) {
                    return;
                }
                
                this.setBusy(contactFormElement, true);
                
                const email = document.getElementById('contact__contact-form-email') as HTMLInputElement;
                const message = document.getElementById('contact__contact-form-message') as HTMLInputElement;
                const softwareName = document.getElementById('contact__contact-form-software-name') as HTMLInputElement;

                // Send form data to server.
                fetch('/contactform/submit', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        email: email.value,
                        message: message.value,
                        softwareName: softwareName.value
                    })
                })
                    .then(response => response.json())
                    .then(data => {
                        // Clear form
                        contactFormElement.classList.remove("was-validated");
                        email.value = '';
                        message.value = '';

                        this.displayMessage("Tack för att du tog dig tid", "Dina synpunkter är värdefulla. Tack för att du tog dig tid att dela med dig av dem!");
                    })
                    .catch(error => {
                        this.displayMessage("Något gick fel", "Kunde inte skicka ditt meddelande. Försök gärna igen senare.");
                    })
                    .finally(() => {
                        this.setBusy(contactFormElement, false);
                    });
            });
        }
    }

    private displayMessage(title: string, message: string): void {
        const modalElement = document.getElementById('messageModal');
        const modal = new Modal(modalElement as HTMLElement);
        const titleElement = modalElement?.querySelector('.modal-title');
        const bodyElement = modalElement?.querySelector('.modal-body');

        if (titleElement) {
            titleElement.innerHTML = title;
        }

        if (bodyElement) {
            bodyElement.innerHTML = message;
        }

        modal.show();
    }
    
    private setBusy(contactFormElement: HTMLElement, isBusy: boolean): void {
        if(isBusy) {
            contactFormElement.getElementsByTagName('fieldset')[0].setAttribute('disabled', '');
            contactFormElement.classList.add('busy');
        }
        else {
            contactFormElement.classList.remove('busy');
            contactFormElement.getElementsByTagName('fieldset')[0].removeAttribute('disabled');
        }
    }
}